module.exports = __webpack_public_path__ + "media/images/profile_check_sp_1-b10131e14e46dcde65f19641fd3ec293.png";